<template>
  <div>
    <div class="bootstrap-wrapper">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <h4>Bridgar på ditt konto</h4>
            <p>Bridgarna i denna lista är sådana som är kopplade till ditt konto och som du har möjlighet att komma åt om de är online. Du kan trycka på någon av nedanstående för att ansluta till den.</p>
          </div>
          
          <div class="col-md-6">
            <h4>Ansluta en ny Nexa Bridge</h4>
            <p>Koppla in din nya Bridge med ström samt nätverk och vänta i cirka 5 minuter. Den kommer automatiskt att dyka upp längst ner på denna vyn under <i>Hittade Bridgar</i>, tryck sedan på <i>Koppla till kontot</i>.</p>
          </div>     
        </div>   
      </div>
    </div>
    
    
    <table>
      <thead>
        <tr>
          <th>Namn</th>
          <th colspan="2"></th>
        </tr>
      </thead>
      
      <tbody>
        <tr v-for="bridge in bridges">
          <td @click="connectTo(bridge)" style="cursor:pointer;">{{ bridge.info.name }}<br /><div :style="{ fontSize: '12px', color: (bridge.connected ? '#2ecc71' : '#e74c3c') }">{{ bridge.connected ? 'Online' : 'Offline' }}</div></td>
          <!--<td align="right" width="90"><a v-if="bridge.connected" href="#" @click="reboot(bridge, $event)">Starta om</a></td>-->
          <td align="right" width="190"><a href="#" @click="remove(bridge, $event)" style="color:#e74c3c;">Ta bort från konto</a></td>
        </tr>
      </tbody>
    </table>
    
    <div v-if="found.length">
      <hr class="space">

      <h4>Hittade Bridgar</h4>
      <p class="descr">Nedanstående Bridgar hittade vi på samma IP-adress som den du befinner dig på nu, det betyder troligtvis att denna är din. Du kan koppla den till kontot genom att trycka på knappen längst åt höger. När du har kopplat den har du möjlighet att komma åt den via internet.</p>

      <table>
        <tbody>
          <tr v-for="bridge in found">
            <td>{{ bridge.name }}</td>
            <td align="right">
              <a v-if="!bridge.connecting" href="#" @click="connectToAccount(bridge, $event)" style="color:#2ecc71;">Koppla till konto</a>
              <a v-else>Kopplar...</a>
            </td>
          </tr>
        </tbody>
      </table>
      
    </div>

  </div>
</template>

<script>
  import { cloud } from '../http.js'
  import swal from 'sweetalert2'

  export default {
    name: 'installningar_cloud',
    data () {
      return {
        bridges: [],
        found2: [],
        getBridgesTimer: null
      }
    },
    created () {
      // Hämta bridgarna som finns på kontot
      cloud.get('bridges')
      .then(res => res.data)
      .then(json => {
        this.bridges = json.filter(bridge => ('name' in bridge && bridge.name))
      })

      this.getBridgesOnIP()
    },
    methods: {
      getBridgesOnIP () {
        cloud.get('find?includeLinked=1')
        .then(res => res.data)
        .then(json => {
          this.found2 = json
          
          // Hämta samma data igen efter 2 minuter
          this.getBridgesTimer = setTimeout(() => this.getBridgesOnIp(), 2*(60*1000))
        })
      },
      
      /**
        Fjärrstartaom en Bridge.
      */
      reboot (bridge, e) {
        e.preventDefault()

        if (confirm('Är du säker på att du vill starta om?')) {
          
        }
      },
      
      /**
        Används för att hoppa mellan olika Bridgar.
      */
      connectTo (bridge) {
        // Kolla så att den är ansluten
        if (bridge.connected) {
          // Sätt kakan
          this.$cookie.set('bridgeId', bridge.id, {
            expires: '7D'
          })
  
          // Ladda om till första vyn så att allt initieras igen,
          // exempelvis HTTP-klienten.
          window.location = '/'
        }
      },
      
      remove (bridge, e) {
        e.preventDefault()

        if (confirm('Du kommer inte att kunna komma åt din Bridge om du tar bort den från ditt konto... vill du fortsätta?')) {
          cloud.delete('bridges/' + bridge.id)

          const index = this.bridges.findIndex(bridge_ => bridge_.id === bridge.id)
          this.bridges.splice(index, 1)
        }
      },
      
      connectToAccount (bridge, e) {
        e.preventDefault()

        const errors = {
          BridgeNotRecentlyStarted: 'Från det att din Nexa Bridge har startat har du 10 minuter på dig att registrera den, starta om den och vänta några minuter och försök sedan igen'
        }
        
        bridge.connecting = true
        
        // Ansluter Bridgen till nuvarande kontot man är inloggad på
        cloud.post('bridges', {
          bridgeid: bridge.id
        })
        .then(res => res.data)
        .then(json => {
          bridge.connecting = false

          if ('cloudResult' in json) {
            if (json.cloudResult in errors) {
              swal('Något gick fel', errors[json.cloudResult], 'error')
            } else {
                        
              this.bridges.push(bridge)
              
              const index = this.found.findIndex(bridge_ => bridge_.id === bridge.id)
              this.found.splice(index, 1)
              
            }
          }
        })
      }
    },
    computed: {
      // Hämtar Bridgar som har kopplats in de 30 senaste minutrarna
      found () {
        return this.found2.filter(bridge => {
          const ago = (new Date() - new Date(bridge.lastConnected)) / 1000
          
          // Kolla så att Bridgen inte redan är kopplad till
          // vårt egna konto samt att det inte har gått för lång tid.
          if (this.bridges.find(b => b.id === bridge.id) || ago > 60*60) {
            return false
          }
          
          return true
        }).map(bridge => {
          bridge.connecting = false
          return bridge
        })
      }
    },
    
    destroyed () {
      clearTimeout(this.getBridgesTimer)
    }
  }
</script>

<style>
  button {
    outline: none;
  }
</style>


// WEBPACK FOOTER //
// src/components/installningar_cloud.vue